import { Controller } from "@hotwired/stimulus"

// Scrolls to the element matching the URL fragment after a turbo-frame loads,
// and adds a highlight class that fades out.
// Usage: data-controller="scroll-to-hash" data-action="turbo:frame-load->scroll-to-hash#scroll"
export default class extends Controller {
	// The stream this binds to reloads on its own — a note locking, a note
	// changing date — and fires scroll again each time. A fragment lands once.
	#landedOn = null

	scroll() {
		const hash = window.location.hash
		if (!hash || hash === this.#landedOn) return

		const el = document.querySelector(hash)
		if (!el) return

		this.#landedOn = hash
		el.scrollIntoView({ behavior: "smooth", block: "center" })
		el.classList.add("note-highlight")
	}
}
